module.exports = __webpack_public_path__ + "static/media/Button.b2328beb.less";


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/Button.less
// module id = 109
// module chunks = 0